/**
 * GoatScale — Black Store Cart Drawer  v5
 * Compatível com Horizon e qualquer tema Shopify moderno.
 * fetch-intercept + XHR-intercept + custom-element neutralization.
 *
 * © GoatScale — Proprietary. Unauthorized copying, reuse or redistribution of this
 * script is prohibited. It is domain-locked and will not function outside authorized stores.
 */
(function () {
  'use strict';

  /* ── Domain lock: only run on authorized GoatScale stores. On any other domain the
     script is INERT (cart, redirect and discount preview all do nothing), so a copied
     theme is useless. The backend injects each store's domain on deploy; for manual
     deploys add the store's .myshopify.com domain to GS_ALLOWED below. ── */
  var GS_ALLOWED = [
    'vqers4-bd.myshopify.com'
  ];
  var _gsShop = (window.Shopify && window.Shopify.shop) || location.hostname;
  if (GS_ALLOWED.indexOf(_gsShop) === -1) {
    try { console.warn('GoatScale: domínio não autorizado — script desativado.'); } catch (e) {}
    return;
  }

  if (window.Shopify && window.Shopify.designMode) return;
  if (window._gsLoaded) return;
  window._gsLoaded = true;

  /* ── Cart drawer i18n — follows the store language (document lang) ── */
  var GSD_LANG = String(document.documentElement.lang || (window.Shopify && Shopify.locale) || 'en').slice(0,2).toLowerCase();
  var GSD_T = {
    cart:        {en:'Cart',pt:'Carrinho',de:'Warenkorb',fr:'Panier',es:'Carrito',it:'Carrello'},
    empty:       {en:'Warenkorb leer',pt:'Seu carrinho está vazio',de:'Dein Warenkorb ist leer',fr:'Votre panier est vide',es:'Tu carrito está vacío',it:'Il tuo carrello è vuoto'},
    subtotal:    {en:'Subtotal',pt:'Subtotal',de:'Zwischensumme',fr:'Sous-total',es:'Subtotal',it:'Subtotale'},
    checkout:    {en:'Checkout',pt:'Finalizar compra',de:'Zur Kasse',fr:'Commander',es:'Finalizar compra',it:'Vai alla cassa'},
    remove:      {en:'Remove',pt:'Remover',de:'Entfernen',fr:'Retirer',es:'Quitar',it:'Rimuovi'},
    bumps:       {en:'Popular combo — special price',pt:'Combo popular — preço especial',de:'Beliebtes Combo — Sonderpreis',fr:'Combo populaire — prix spécial',es:'Combo popular — precio especial',it:'Combo popolare — prezzo speciale'},
    add:         {en:'Add',pt:'Adicionar',de:'Hinzufügen',fr:'Ajouter',es:'Añadir',it:'Aggiungi'},
    redirecting: {en:'Redirecting...',pt:'Redirecionando...',de:'Weiterleitung...',fr:'Redirection...',es:'Redirigiendo...',it:'Reindirizzamento...'},
    ship:        {en:'Free shipping<br>nationwide',pt:'Frete grátis<br>para todo o país',de:'Kostenloser<br>Versand',fr:'Livraison<br>gratuite',es:'Envío gratis<br>a todo el país',it:'Spedizione<br>gratuita'},
    guarantee:   {en:'30-day<br>money back',pt:'30 dias<br>de garantia',de:'30 Tage<br>Geld zurück',fr:'30 jours<br>remboursé',es:'30 días<br>de garantía',it:'30 giorni<br>rimborso'},
    secure:      {en:'100% secure<br>payment',pt:'Pagamento<br>100% seguro',de:'100% sichere<br>Zahlung',fr:'Paiement<br>100% sécurisé',es:'Pago<br>100% seguro',it:'Pagamento<br>100% sicuro'},
    gift_title:  {en:'Choose your free perfume',pt:'Escolha o seu perfume grátis',de:'Wähle dein Gratis-Parfüm',fr:'Choisissez votre parfum offert',es:'Elige tu perfume gratis',it:'Scegli il tuo profumo omaggio'},
    gift_chosen: {en:'Your free perfume',pt:'O seu perfume grátis',de:'Dein Gratis-Parfüm',fr:'Votre parfum offert',es:'Tu perfume gratis',it:'Il tuo profumo in omaggio'},
    gift_choose: {en:'Choose',pt:'Escolher',de:'Wählen',fr:'Choisir',es:'Elegir',it:'Scegli'},
    gift_free:   {en:'FREE',pt:'GRÁTIS',de:'GRATIS',fr:'OFFERT',es:'GRATIS',it:'OMAGGIO'},
    d_savings:   {en:'Total savings',pt:'Economia total',de:'Gesamtersparnis',fr:'Économies totales',es:'Ahorro total',it:'Risparmio totale'},
    d_kit:       {en:'Kit bundle',pt:'Combo de kits',de:'Kit-Bundle',fr:'Pack kits',es:'Combo de kits',it:'Bundle kit'},
    d_pick3:     {en:'Pick 3 Pay 1',pt:'Leve 3 Pague 1',de:'3 für 1',fr:'3 pour 1',es:'Lleva 3 Paga 1',it:'Prendi 3 Paghi 1'},
    d_vol:       {en:'Volume',pt:'Volume',de:'Menge',fr:'Volume',es:'Volumen',it:'Volume'}
  };
  function _gt(k){ var d=GSD_T[k]; return d ? (d[GSD_LANG]||d.en) : k; }

  /* ═══════════════════════════════════════════════════════════════
     SVG ICONS
  ═══════════════════════════════════════════════════════════════ */
  var ICONS = {
    plane:   '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2 11 13"/><path d="M22 2 15 22 11 13 2 9l20-7z"/></svg>',
    shield:  '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>',
    lock:    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    /* ── Progress bar milestone icons (16×16) ── */
    truck:   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    gift:    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    star:    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
    heart:   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    percent: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>',
    crown:   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 20h20M4 20V10l4 4 4-8 4 8 4-4v10"/></svg>',
    diamond: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h12l4 6-10 13L2 9z"/><path d="M2 9h20M6 3l4 6m8-6-4 6"/></svg>',
    trophy:  '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9H4a2 2 0 0 1-2-2V5h4m14 4h2a2 2 0 0 0 2-2V5h-4"/><path d="M6 5h12v7a6 6 0 0 1-12 0V5z"/><path d="M8 21v-3m8 3v-3m-8 0h8"/></svg>',
    zap:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    sparkle: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v3m0 12v3M3 12h3m12 0h3M5.6 5.6l2.1 2.1m8.6 8.6 2.1 2.1M5.6 18.4l2.1-2.1m8.6-8.6 2.1-2.1"/></svg>',
    check:   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>',
    bag:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
    tag:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>',
    box:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',
    rocket:  '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>',
    leaf:    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>',
    sun:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>',
    smile:   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>',
  };

  /* ═══════════════════════════════════════════════════════════════
     CSS
  ═══════════════════════════════════════════════════════════════ */
  var css = [
    /* ── Hide "Buy it now" + ALL native Shopify cart elements ── */
    '.shopify-payment-button,.shopify-payment-button__button',
    ',[data-shopify="payment-button"],.product-form__payment',
    ',#dynamic-checkout-cart,.dynamic-checkout__content',
    ',cart-notification,#cart-notification,.cart-notification,#CartNotification',
    ',cart-drawer,#CartDrawer,.cart-drawer,.cart-drawer-container',
    ',#cart-drawer-overlay,.cart-overlay,.cart-drawer-overlay',
    ',cart-drawer-items,.CartDrawer,.CartDrawer-Form',
    '{display:none!important;visibility:hidden!important;pointer-events:none!important}',

    /* ── Backdrop ── */
    '#gs-bd{position:fixed;inset:0;background:rgba(0,0,0,.45)',
    ';z-index:9998;opacity:0;pointer-events:none;transition:opacity .28s}',
    '#gs-bd.on{opacity:1;pointer-events:all}',

    /* ── Drawer ── */
    '#gs-dw{position:fixed;top:0;right:0;bottom:0;width:420px;max-width:100vw',
    ';background:#fff;z-index:9999;display:flex;flex-direction:column',
    ';transform:translateX(100%);transition:transform .32s cubic-bezier(.4,0,.2,1)',
    ';box-shadow:-6px 0 32px rgba(0,0,0,.14)',
    ';font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}',
    '#gs-dw.on{transform:translateX(0)}',

    /* ── Header ── */
    '.gs-hd{display:flex;align-items:center;justify-content:space-between',
    ';padding:17px 20px;border-bottom:1px solid #ebebeb}',
    '.gs-hd-t{font-size:16px;font-weight:700;color:#111}',
    '.gs-hd-n{background:#111;color:#fff;font-size:11px;font-weight:700',
    ';border-radius:50%;width:22px;height:22px',
    ';display:inline-flex;align-items:center;justify-content:center;margin-left:8px}',
    '.gs-x{background:none;border:none;cursor:pointer;color:#888',
    ';padding:4px;border-radius:4px;line-height:1;font-size:20px}',
    '.gs-x:hover{background:#f5f5f5;color:#111}',

    /* ── Body ── */
    '.gs-bd2{flex:1;overflow-y:auto}',
    '.gs-empty{padding:52px 20px;text-align:center;color:#aaa;font-size:14px}',

    /* ── Cart items ── */
    '.gs-it{display:flex;gap:13px;padding:15px 20px;border-bottom:1px solid #f2f2f2}',
    '.gs-it-img{width:72px;height:72px;object-fit:cover;border-radius:9px',
    ';background:#f5f5f5;flex-shrink:0;border:1px solid #ebebeb}',
    '.gs-it-inf{flex:1;min-width:0}',
    '.gs-it-ttl{font-size:13px;font-weight:600;margin:0 0 2px;line-height:1.35;color:#111}',
    '.gs-it-var{font-size:11px;color:#999;margin:0 0 5px}',
    '.gs-it-pr{font-size:14px;font-weight:700;margin:0 0 9px;color:#111}',
    '.gs-it-was{font-size:12px;font-weight:500;color:#9b9b9b;text-decoration:line-through;margin-left:7px}',
    '.gs-it-row{display:flex;align-items:center;justify-content:space-between}',
    '.gs-qty{display:flex;align-items:center;border:1px solid #ddd;border-radius:7px;overflow:hidden}',
    '.gs-qb{background:none;border:none;cursor:pointer;width:32px;height:30px',
    ';font-size:16px;display:flex;align-items:center;justify-content:center;color:#333}',
    '.gs-qb:hover{background:#f5f5f5}',
    '.gs-qn{font-size:13px;font-weight:600;min-width:28px;text-align:center;color:#111}',
    '.gs-rm{background:none;border:none;cursor:pointer;font-size:11px',
    ';color:#ccc;text-decoration:underline;padding:0}',
    '.gs-rm:hover{color:#e00}',

    /* ── Bumps ── */
    '.gs-bh{background:#fafafa;border-top:2px solid #111;border-bottom:1px solid #ebebeb',
    ';padding:9px 20px;font-size:11px;font-weight:700;color:#111',
    ';text-align:center;text-transform:uppercase;letter-spacing:.8px}',
    '.gs-bmp{display:flex;align-items:center;gap:12px;padding:11px 20px;border-bottom:1px solid #f2f2f2}',
    '.gs-bmp-img{width:54px;height:54px;object-fit:cover;border-radius:8px',
    ';background:#f5f5f5;flex-shrink:0;border:1px solid #ebebeb}',
    '.gs-bmp-inf{flex:1;min-width:0}',
    '.gs-bmp-t{font-size:12px;font-weight:600;margin:0 0 3px;line-height:1.3;color:#111',
    ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.gs-bmp-p{font-size:12.5px;font-weight:700;color:#111}',
    '.gs-bmp-was{font-size:11px;font-weight:500;color:#9b9b9b;text-decoration:line-through;margin-left:7px}',
    '.gs-bmp-btn{background:#111;color:#fff;border:none;cursor:pointer',
    ';font-size:11px;font-weight:700;padding:8px 13px;border-radius:7px',
    ';white-space:nowrap;flex-shrink:0;transition:background .15s}',
    '.gs-bmp-btn:hover{background:#333}',
    '.gs-bmp-btn:disabled{background:#ccc;cursor:default}',
    '.gs-bmp-btn.ok{background:#111}',
    /* ── Toggle bump ── */
    '.gs-tgl{position:relative;width:42px;height:24px;flex-shrink:0}',
    '.gs-tgl input{opacity:0;width:0;height:0;position:absolute}',
    '.gs-tgl-sl{position:absolute;inset:0;background:#ccc;border-radius:24px',
    ';cursor:pointer;transition:background .2s}',
    '.gs-tgl-sl:before{content:"";position:absolute;width:18px;height:18px',
    ';left:3px;top:3px;background:#fff;border-radius:50%;transition:transform .2s}',
    '.gs-tgl input:checked+.gs-tgl-sl{background:#111}',
    '.gs-tgl input:checked+.gs-tgl-sl:before{transform:translateX(18px)}',

    /* ── Footer ── */
    '.gs-ft{border-top:1px solid #ebebeb;padding:16px 20px;background:#fff}',
    '.gs-sub{display:flex;justify-content:space-between;align-items:baseline',
    ';font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:.5px',
    ';margin-bottom:13px;color:#111}',
    '.gs-sub-v{font-size:18px;font-weight:800}',
    '.gs-ck{width:100%;background:#111;color:#fff;border:none;cursor:pointer',
    ';font-size:15px;font-weight:700;padding:16px;border-radius:9px;margin-bottom:14px',
    ';transition:background .18s,transform .1s}',
    '.gs-ck:hover{background:#2a2a2a}',
    '.gs-ck:active{transform:scale(.98)}',
    '.gs-ck:disabled{background:#bbb;cursor:default}',

    /* ── Cart Progress Bar — v7 (legible font, large image bullet) ── */
    '@keyframes gspbShine{0%{left:-35%}100%{left:135%}}',
    '#gs-prog{padding:11px 18px 11px;border-bottom:1px solid #efefef;background:#fff}',
    "#gspb-msg{font-family:'Montserrat',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    ';font-weight:600;font-size:14px;color:#111;text-align:center',
    ';margin-bottom:9px;line-height:1.3;letter-spacing:-.01em;min-height:18px}',
    '.gspb-wrap{position:relative;height:34px;margin:3px 14px 26px}',
    '.gspb-rail{position:absolute;left:0;right:0;top:14px;height:6px',
    ';border-radius:99px;background:#e7e7ea;overflow:hidden}',
    '.gspb-fill{position:absolute;left:0;top:0;height:100%;width:0',
    ';background:linear-gradient(90deg,#000,#1c1c1c);border-radius:99px;overflow:hidden}',
    '.gspb-shine{position:absolute;top:0;bottom:0;left:-35%;width:35%',
    ';background:linear-gradient(100deg,transparent 0%,rgba(255,255,255,.6) 50%,transparent 100%)',
    ';animation:gspbShine 2.8s ease-in-out infinite;pointer-events:none}',
    /* Milestone — centred on the rail via translate (works at any size) */
    '.gspb-mw{position:absolute;top:0;width:0;height:0}',
    '.gspb-mc{position:absolute;left:0;top:17px;transform:translate(-50%,-50%)',
    ';width:34px;height:34px;border-radius:50%;background:#e7e7ea',
    ';color:#bcbcbc;display:flex;align-items:center;justify-content:center',
    ';transition:background .35s,box-shadow .35s,color .35s,border-color .35s',
    ';border:2.5px solid #fff;box-sizing:border-box}',
    '.gspb-mc svg{width:16px;height:16px;display:block;flex-shrink:0}',
    '.gspb-mc img{width:16px;height:16px;border-radius:3px;object-fit:cover;display:block}',
    '.gspb-mc.on{background:var(--gspb-color,#34c759);color:#fff',
    ';border-color:var(--gspb-color,#34c759)',
    ';box-shadow:0 3px 12px rgba(0,0,0,.22),0 0 0 3px rgba(0,0,0,.06)}',
    /* Image bullet — product rests on a clean circular badge, floating in front */
    '.gspb-mc--img{width:40px;height:40px;padding:0;overflow:visible;border:2px solid #fff',
    ';background:radial-gradient(circle at 50% 34%,#fff,#eceef1)',
    ';box-shadow:0 2px 8px rgba(0,0,0,.15),inset 0 1px 1px rgba(255,255,255,.9)}',
    '.gspb-mc--img img{position:absolute;left:50%;top:44%;transform:translate(-50%,-50%)',
    ';width:46px;height:46px;border-radius:0;object-fit:contain;padding:0;box-sizing:border-box',
    ';background:transparent;z-index:6;filter:drop-shadow(0 4px 6px rgba(0,0,0,.32))}',
    '.gspb-mc--img.on{border-color:#fff',
    ';background:radial-gradient(circle at 50% 34%,#fff,#e6fbf0)',
    ';box-shadow:0 5px 16px rgba(34,163,90,.34),0 0 0 4px rgba(34,163,90,.18),inset 0 1px 1px rgba(255,255,255,.9)}',
    '.gspb-mc--img:not(.on) img{filter:grayscale(.5) drop-shadow(0 3px 5px rgba(0,0,0,.18));opacity:.66}',
    /* Value labels — aligned on one line below the bullets */
    '.gspb-lv{position:absolute;left:0;top:48px;transform:translateX(-50%);white-space:nowrap',
    ';font-size:9.5px;font-weight:700;letter-spacing:.02em',
    ';color:#bcbcbc;text-align:center;transition:color .35s}',
    '.gspb-lv.on{color:var(--gspb-color,#34c759)}',
    '@media(max-width:400px){.gspb-mc{width:30px;height:30px}',
    '.gspb-mc--img{width:36px;height:36px}.gspb-mc--img img{width:42px;height:42px}',
    '.gspb-mc svg,.gspb-mc img{width:13px;height:13px}',
    '.gspb-lv{font-size:8.5px;top:44px}}',

        /* ── Trust badges ── */
    '.gs-tr{display:flex;justify-content:space-around;padding-top:2px}',
    '.gs-tr-i{display:flex;flex-direction:column;align-items:center;gap:5px',
    ';color:#333;flex:1;text-align:center}',
    '.gs-tr-ic{display:flex;justify-content:center;color:#111}',
    '.gs-tr-lb{font-size:9.5px;font-weight:500;line-height:1.3;color:#777}',
    /* ── Free perfume picker (unlocked at last milestone) ── */
    '#gs-gift{padding:10px 14px 11px;border-bottom:1px solid #e6e6e6;background:linear-gradient(180deg,#eafff3,#f6fffb);flex:0 0 auto}',
    ".gs-gift-h{display:flex;align-items:center;gap:7px;font-family:'Montserrat',sans-serif;font-weight:700;font-size:12.5px;color:#111;margin-bottom:9px}",
    '.gs-gift-h svg{width:17px;height:17px;color:#22a35a;flex-shrink:0}',
    '.gs-gift-row{display:flex;gap:9px;overflow-x:auto;padding:1px 1px 5px;-webkit-overflow-scrolling:touch;scrollbar-width:thin}',
    '.gs-gift-row::-webkit-scrollbar{height:5px}',
    '.gs-gift-row::-webkit-scrollbar-thumb{background:#d8d8db;border-radius:9px}',
    '.gs-gp{flex:0 0 auto;width:104px;border:1.5px solid #ececec;border-radius:12px;background:#fff;padding:8px;box-sizing:border-box;transition:border-color .15s,box-shadow .15s}',
    '.gs-gp.sel{border-color:#22a35a;box-shadow:0 0 0 3px rgba(34,163,90,.15)}',
    '.gs-gp-img{width:100%;height:74px;object-fit:contain;display:block;margin-bottom:6px}',
    ".gs-gp-nm{font-family:'Montserrat',sans-serif;font-weight:600;font-size:10.5px;line-height:1.25;color:#222;height:26px;overflow:hidden;text-align:center;margin-bottom:6px}",
    '.gs-gp-bd{display:flex;gap:4px;justify-content:center;margin-bottom:7px}',
    ".gs-bdg{font-family:'Montserrat',sans-serif;font-weight:700;font-size:8px;letter-spacing:.03em;padding:3px 5px;border-radius:5px;white-space:nowrap;line-height:1}",
    '.gs-bdg-ml{background:#eef1f4;color:#3a3f47}',
    '.gs-bdg-free{background:#22a35a;color:#fff}',
    ".gs-gp-btn{width:100%;border:none;border-radius:8px;background:#111;color:#fff;font-family:'Montserrat',sans-serif;font-weight:700;font-size:10.5px;padding:8px 0;cursor:pointer;transition:background .15s}",
    '.gs-gp-btn:hover{background:#000}',
    '.gs-gp.sel .gs-gp-btn{background:#22a35a;cursor:default}',
  ].join('');

  var st = document.createElement('style');
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  /* ═══════════════════════════════════════════════════════════════
     HIDE BUY IT NOW — CSS + JS + MutationObserver (dinâmico)
  ═══════════════════════════════════════════════════════════════ */
  var BIN_SELS = [
    '[data-shopify="payment-button"]',
    '.shopify-payment-button',
    '.shopify-payment-button__button',
    '.product-form__payment',
    '#dynamic-checkout-cart',
    '.dynamic-checkout__content',
    'cart-notification',
    '#cart-notification',
    '.cart-notification',
    '#CartNotification',
  ];

  function hideBIN() {
    BIN_SELS.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
      });
    });
  }

  hideBIN();
  if (window.MutationObserver) {
    new MutationObserver(hideBIN).observe(
      document.documentElement,
      { childList: true, subtree: true }
    );
  }

  /* ═══════════════════════════════════════════════════════════════
     HTML DRAWER
  ═══════════════════════════════════════════════════════════════ */
  function injectDrawer() {
    if (document.getElementById('gs-dw')) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = [
      '<div id="gs-bd"></div>',
      '<div id="gs-dw">',
        '<div class="gs-hd">',
          '<div><span class="gs-hd-t">'+_gt('cart')+'</span>',
          '<span class="gs-hd-n" id="gs-cnt">0</span></div>',
          '<button class="gs-x" id="gs-x">&#x2715;</button>',
        '</div>',
        '<div id="gs-prog" style="display:none">',
          '<div id="gspb-msg"></div>',
          '<div class="gspb-wrap">',
            '<div class="gspb-rail"><div class="gspb-fill" id="gspb-fill"><span class="gspb-shine"></span></div></div>',
            '<div id="gspb-miles"></div>',
          '</div>',
        '</div>',
                '<div class="gs-bd2" id="gs-bd2">',
          '<div class="gs-empty">'+_gt('empty')+'</div>',
        '</div>',
        '<div class="gs-ft" id="gs-ft" style="display:none">',
          '<div id="gs-disc"></div>',
          '<div class="gs-sub"><span>'+_gt('subtotal')+'</span>',
          '<span class="gs-sub-v" id="gs-sv">$0.00</span></div>',
          '<button class="gs-ck" id="gs-ck">'+_gt('checkout')+'</button>',
          '<div class="gs-tr">',
            '<div class="gs-tr-i">',
              '<span class="gs-tr-ic">' + ICONS.plane  + '</span>',
              '<span class="gs-tr-lb">'+_gt('ship')+'</span>',
            '</div>',
            '<div class="gs-tr-i">',
              '<span class="gs-tr-ic">' + ICONS.shield + '</span>',
              '<span class="gs-tr-lb">'+_gt('guarantee')+'</span>',
            '</div>',
            '<div class="gs-tr-i">',
              '<span class="gs-tr-ic">' + ICONS.lock   + '</span>',
              '<span class="gs-tr-lb">'+_gt('secure')+'</span>',
            '</div>',
          '</div>',
        '</div>',
      '</div>',
    ].join('');
    while (wrap.firstChild) document.body.appendChild(wrap.firstChild);
    document.getElementById('gs-x').addEventListener('click', closeD);
    document.getElementById('gs-bd').addEventListener('click', closeD);
    document.getElementById('gs-ck').addEventListener('click', doCheckout);
  }

  /* ═══════════════════════════════════════════════════════════════
     NEUTRALIZE HORIZON NATIVE CART ELEMENTS
     Patches open()/show()/renderContents() so theme JS can't
     reveal its own drawer even after we hide it with CSS.
  ═══════════════════════════════════════════════════════════════ */
  var NEUTRALIZE_METHODS = ['open', 'show', 'renderContents', 'getSectionsToRender'];

  function neutralizeElement(el) {
    if (!el || el._gsNeutralized) return;
    el._gsNeutralized = true;
    NEUTRALIZE_METHODS.forEach(function (m) {
      if (typeof el[m] === 'function') {
        el[m] = function () { return Promise.resolve(); };
      }
    });
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
  }

  function neutralizeNativeCart() {
    ['cart-drawer', 'cart-notification', 'cart-drawer-items'].forEach(function (tag) {
      document.querySelectorAll(tag).forEach(neutralizeElement);
    });
  }

  /* ═══════════════════════════════════════════════════════════════
     OPEN / CLOSE
  ═══════════════════════════════════════════════════════════════ */
  function openD() {
    var d = document.getElementById('gs-dw');
    var b = document.getElementById('gs-bd');
    if (!d) return;
    d.classList.add('on'); b.classList.add('on');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ gspbAnimate(); });
  }
  function closeD() {
    var d = document.getElementById('gs-dw');
    var b = document.getElementById('gs-bd');
    if (!d) return;
    d.classList.remove('on'); b.classList.remove('on');
    document.body.style.overflow = '';
    // Native Shopify cart-drawer.open() adds 'overflow-hidden' to <body> and is
    // hidden via CSS, so its lock is never cleared by the native close. Clear it
    // here so the page scroll is restored when the custom drawer closes.
    document.body.classList.remove('overflow-hidden');
  }

  /* ═══════════════════════════════════════════════════════════════
     HELPERS
  ═══════════════════════════════════════════════════════════════ */
  var _gsCurrency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  function $m(c) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined,
        { style:'currency', currency:_gsCurrency, minimumFractionDigits:2, maximumFractionDigits:2 }
      ).format((c||0)/100);
    } catch(e) { return ((c||0)/100).toFixed(2); }
  }
  function esc(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function resizeImg(url, sz) {
    if (!url) return '';
    if (url.startsWith('//')) url = 'https:' + url;
    return url.replace(/(\.[^.?#]+)(\?.*)?$/, '_' + sz + '$1$2');
  }

  /* ═══════════════════════════════════════════════════════════════
     PRÉ-CARREGAMENTO DOS BUMPS (chamado no init)
  ═══════════════════════════════════════════════════════════════ */
  function prefetchBumps(cb) {
    fetch('/collections/goatscale-bumps/products.json?limit=12')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        _bumpsData    = d.products || [];
        _toggleVarIds = {};
        _bumpsData.forEach(function (p) {
          if (hasTag(p, 'goatscale-toggle') || hasTag(p, 'goatscale-autoadd')) {
            var v = p.variants && p.variants[0];
            if (v) _toggleVarIds[String(v.id)] = true;
          }
        });
        if (cb) cb();
      })
      .catch(function () { if (cb) cb(); });
  }

  /* ═══════════════════════════════════════════════════════════════
     DISCOUNT PREVIEW — mirrors the White store discount function.
     Visual only: the real discount is applied by the Shopify Function
     at the White checkout. Keep the rules in sync with run.js.
  ═══════════════════════════════════════════════════════════════ */
  var GS_KIT_SKU  = /^\d{2}$/;     // kits "01".."20"
  var GS_IND_SKU  = /^P\d{2}$/;    // individuals "P01".."P54"
  var GS_GIFT_MIN = 12990;          // cents — gift unlocks when cart (excl. gift) >= this

  // Cart total EXCLUDING the free-gift line — used for progress bar + gift/free-shipping
  // thresholds, so the gift never "sustains itself" above a milestone.
  function gsNonGiftCents(cart) {
    var items = (cart && cart.items) || [];
    var giftCents = items.reduce(function (s, it) {
      return s + ((it.properties && it.properties[GIFT_PROP]) ? (it.line_price || 0) : 0);
    }, 0);
    return Math.max(0, (cart && cart.total_price || 0) - giftCents);
  }

  function computeGsDiscounts(cart) {
    var _it = (cart && cart.items) || [], _pl = {};
    _it.forEach(function (x) { _pl[x.key] = { off: 0, label: '', free: false }; });
    return { perLine: _pl, kitPct: 0, kitOff: 0, totalSavings: 0, finalTotal: (cart && cart.total_price) || 0 };
  }
  function _computeGsDiscountsUnused(cart) {
    var items = (cart && cart.items) || [];
    var perLine = {};
    var lines = items.map(function (it) {
      perLine[it.key] = { off: 0, label: '', free: false };
      var sku = (it.sku || '').trim().replace(/^'+/, '');
      return {
        key: it.key, sku: sku, qty: it.quantity || 1,
        unit: it.price || 0, linePrice: it.line_price || 0,
        isGift: !!(it.properties && it.properties[GIFT_PROP]),
        isKit: GS_KIT_SKU.test(sku), isInd: GS_IND_SKU.test(sku)
      };
    });

    // Free gift: the picker only keeps the gift line when cart-minus-gift >= €129.90, so when a
    // gift line exists it is valid → always free it and exclude it from Pick 3.
    var giftLine = null;
    for (var g = 0; g < lines.length; g++) {
      if (lines[g].isGift && lines[g].isInd) { giftLine = lines[g]; break; }
    }
    var giftKey = giftLine ? giftLine.key : null;
    if (giftLine) {
      perLine[giftLine.key].off += giftLine.unit * giftLine.qty;
      perLine[giftLine.key].free = true;
      perLine[giftLine.key].label = _gt('gift_free');
    }

    // Pick 3 Pay 1: distinct individuals (excl. the gift line); every 3 -> 2 cheapest free (1 unit).
    var indLines = lines.filter(function (l) { return l.isInd && l.key !== giftKey; });
    var distinct = indLines.slice().sort(function (a, b) { return a.unit - b.unit; });
    var freeCount = Math.floor(distinct.length / 3) * 2;
    var freedKeys = {}, freed = 0;
    for (var i = 0; i < distinct.length && freed < freeCount; i++) {
      if (i % 3 === 2) continue;
      var l = distinct[i];
      perLine[l.key].off += l.unit;
      perLine[l.key].free = (l.qty === 1);
      perLine[l.key].label = _gt('d_pick3');
      freedKeys[l.key] = true;
      freed++;
    }

    // Volume: same perfume qty>=2 (not freed by Pick 3) -> 2:15%, 3+:25%.
    indLines.filter(function (l) { return l.qty >= 2 && !freedKeys[l.key]; }).forEach(function (l) {
      var pct = l.qty >= 3 ? 25 : 15;
      perLine[l.key].off += Math.round(l.linePrice * pct / 100);
      perLine[l.key].label = _gt('d_vol') + ' −' + pct + '%';
    });

    var originalTotal = lines.reduce(function (s, l) { return s + l.linePrice; }, 0);
    var lineDiscounts = Object.keys(perLine).reduce(function (s, k) { return s + perLine[k].off; }, 0);
    var afterLine = Math.max(0, originalTotal - lineDiscounts);

    // Kits (GS Add-on Bundle): 2 kits -> 10%, 3+ -> 15% off the whole cart (order discount).
    var totalKitQty = lines.filter(function (l) { return l.isKit; }).reduce(function (s, l) { return s + l.qty; }, 0);
    var kitPct = totalKitQty >= 3 ? 15 : (totalKitQty === 2 ? 10 : 0);
    var kitOff = kitPct > 0 ? Math.round(afterLine * kitPct / 100) : 0;

    return {
      perLine: perLine, kitPct: kitPct, kitOff: kitOff,
      totalSavings: lineDiscounts + kitOff,
      finalTotal: Math.max(0, afterLine - kitOff)
    };
  }

  /* ═══════════════════════════════════════════════════════════════
     RENDER CART
  ═══════════════════════════════════════════════════════════════ */
  function renderCart(cart) {
    if (cart && cart.currency) _gsCurrency = cart.currency;
    var body = document.getElementById('gs-bd2');
    var ft   = document.getElementById('gs-ft');
    var cnt  = document.getElementById('gs-cnt');
    var sv   = document.getElementById('gs-sv');
    if (!body) return;

    // Brinde (perfume grátis) — mostrado só na secção do picker, fora dos itens pagos
    var giftItems = (cart.items || []).filter(function (it) { return it.properties && it.properties[GIFT_PROP]; });
    var giftCents = giftItems.reduce(function (s, it) { return s + (it.line_price || 0); }, 0);
    var giftQty   = giftItems.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);

    // Itens visíveis = todos excepto toggle bumps e o brinde
    var visibleItems = (cart.items || []).filter(function (it) {
      if (it.properties && it.properties[GIFT_PROP]) return false;
      return !_toggleVarIds[String(it.variant_id)];
    });

    cnt.textContent = Math.max(0, (cart.item_count || 0) - giftQty);

    // Brinde órfão (sem nenhum item pago) — remove para não ficar preso no carrinho
    if (!visibleItems.length && giftItems.length) {
      var _go = {}; giftItems.forEach(function (it) { _go[it.key] = 0; });
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: _go }),
      }).then(function () { refreshCart(); }).catch(function () {});
    }

    if (!visibleItems.length && !Object.keys(_toggleVarIds).length) {
      var _sg = document.getElementById('gs-gift'); if (_sg) _sg.remove();
      body.innerHTML = '<div class="gs-empty">'+_gt('empty')+'</div>';
      ft.style.display = 'none';
      return;
    }
    if (!cart.item_count) {
      var _sg = document.getElementById('gs-gift'); if (_sg) _sg.remove();
      body.innerHTML = '<div class="gs-empty">'+_gt('empty')+'</div>';
      ft.style.display = 'none';
      return;
    }
    ft.style.display = '';
    var disc = computeGsDiscounts(cart);
    sv.textContent = $m(disc.finalTotal);
    var discEl = document.getElementById('gs-disc');
    if (discEl) {
      var dh = '';
      if (disc.kitOff > 0) {
        dh += '<div class="gs-sub" style="font-size:13px;font-weight:600;color:#0a8a0a;margin-bottom:6px">' +
          '<span>'+_gt('d_kit')+' −'+disc.kitPct+'%</span><span>−'+$m(disc.kitOff)+'</span></div>';
      }
      if (disc.totalSavings > 0) {
        dh += '<div class="gs-sub" style="font-size:13px;font-weight:700;color:#0a8a0a;margin-bottom:6px">' +
          '<span>'+_gt('d_savings')+'</span><span>−'+$m(disc.totalSavings)+'</span></div>';
      }
      discEl.innerHTML = dh;
    }

    body.innerHTML = visibleItems.map(function (it) {
      var img = resizeImg(it.image, '160x160');
      var d = disc.perLine[it.key] || { off: 0, label: '', free: false };
      var net = Math.max(0, it.line_price - d.off);
      return '<div class="gs-it">' +
        (img ? '<img class="gs-it-img" src="'+esc(img)+'" alt="'+esc(it.product_title)+'" loading="lazy">'
             : '<div class="gs-it-img"></div>') +
        '<div class="gs-it-inf">' +
          '<p class="gs-it-ttl">' + esc(it.product_title) + '</p>' +
          (it.variant_title && it.variant_title !== 'Default Title'
            ? '<p class="gs-it-var">' + esc(it.variant_title) + '</p>' : '') +
          '<p class="gs-it-pr">' +
            (d.off > 0
              ? (net === 0
                  ? '<span style="color:#0a8a0a;font-weight:800">'+_gt('gift_free')+'</span>'
                  : $m(net)) +
                ' <s class="gs-it-was">'+$m(it.line_price)+'</s>'
              : $m(it.line_price) +
                (_bumpCompare[String(it.variant_id)] && _bumpCompare[String(it.variant_id)] * it.quantity > it.line_price
                  ? ' <s class="gs-it-was">' + $m(_bumpCompare[String(it.variant_id)] * it.quantity) + '</s>' : '')) +
            (d.label ? ' <span style="display:inline-block;background:#0a8a0a;color:#fff;font-size:10px;font-weight:700;padding:1px 6px;border-radius:10px;margin-left:4px;vertical-align:middle">'+esc(d.label)+'</span>' : '') +
          '</p>' +
          '<div class="gs-it-row">' +
            '<div class="gs-qty">' +
              '<button class="gs-qb" data-key="'+esc(it.key)+'" data-q="'+(it.quantity-1)+'">&#8722;</button>' +
              '<span class="gs-qn">' + it.quantity + '</span>' +
              '<button class="gs-qb" data-key="'+esc(it.key)+'" data-q="'+(it.quantity+1)+'">+</button>' +
            '</div>' +
            '<button class="gs-rm" data-key="'+esc(it.key)+'">'+_gt('remove')+'</button>' +
          '</div>' +
        '</div></div>';
    }).join('');

    body.querySelectorAll('.gs-qb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeQty(btn.dataset.key, parseInt(btn.dataset.q, 10));
      });
    });
    body.querySelectorAll('.gs-rm').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQty(btn.dataset.key, 0); });
    });

    renderProgress(cart);
    renderGiftPicker(cart);
    loadBumps(cart);
    prebuildCheckout(cart);   // warm the White checkout URL + connection for instant checkout
  }

  /* ═══════════════════════════════════════════════════════════════
     CART PROGRESS BAR
  ═══════════════════════════════════════════════════════════════ */
  /* ── Cart progress phrases — i18n (reward + style) ── */
  var GSP_REWARDS = {
    free_shipping:{en:"free shipping",pt:"frete grátis",de:"kostenlosen Versand",fr:"la livraison gratuite",es:"el envío gratis",it:"la spedizione gratuita"},
    free_perfume: {en:"a free perfume",pt:"um perfume grátis",de:"ein Gratis-Parfüm",fr:"un parfum offert",es:"un perfume gratis",it:"un profumo in omaggio"},
    free_gift:    {en:"a free gift",pt:"um brinde",de:"ein Geschenk",fr:"un cadeau",es:"un regalo",it:"un regalo"},
    discount:     {en:"a discount",pt:"um desconto",de:"einen Rabatt",fr:"une réduction",es:"un descuento",it:"uno sconto"},
    vip:          {en:"VIP status",pt:"status VIP",de:"VIP-Status",fr:"le statut VIP",es:"estatus VIP",it:"lo status VIP"}
  };
  var GSP_PENDING = {
    casual:  {en:"You're just {n} away from {r}!",pt:"Falta só {n} para ganhar {r}!",de:"Nur noch {n} bis {r}!",fr:"Plus que {n} pour {r} !",es:"¡Solo {n} para {r}!",it:"Ancora {n} per {r}!"},
    urgency: {en:"Only {n} left to unlock {r}!",pt:"Faltam apenas {n} para desbloquear {r}!",de:"Nur noch {n}, um {r} freizuschalten!",fr:"Plus que {n} pour débloquer {r} !",es:"¡Solo quedan {n} para desbloquear {r}!",it:"Solo {n} per sbloccare {r}!"},
    elegant: {en:"Add {n} more to enjoy {r}.",pt:"Adicione mais {n} e aproveite {r}.",de:"Füge {n} hinzu und genieße {r}.",fr:"Ajoutez {n} pour profiter de {r}.",es:"Añade {n} y disfruta de {r}.",it:"Aggiungi {n} e goditi {r}."},
    playful: {en:"Psst... {n} more and {r} is yours!",pt:"Psiu... mais {n} e {r} é seu!",de:"Pssst... noch {n} und {r} gehört dir!",fr:"Psst... {n} de plus et {r} est à vous !",es:"Psst... {n} más y {r} es tuyo!",it:"Psst... altri {n} e {r} è tuo!"},
    minimal: {en:"{n} to {r}",pt:"{n} para {r}",de:"{n} bis {r}",fr:"{n} pour {r}",es:"{n} para {r}",it:"{n} per {r}"}
  };
  var GSP_REACHED = {
    casual:  {en:"You've unlocked {r}!",pt:"Você ganhou {r}!",de:"Du hast {r} freigeschaltet!",fr:"Vous avez débloqué {r} !",es:"¡Has desbloqueado {r}!",it:"Hai sbloccato {r}!"},
    urgency: {en:"Done! {r} is yours!",pt:"Pronto! {r} é seu!",de:"Fertig! {r} gehört dir!",fr:"Terminé ! {r} est à vous !",es:"¡Listo! {r} es tuyo!",it:"Fatto! {r} è tuo!"},
    elegant: {en:"Enjoy {r}, with our compliments.",pt:"Aproveite {r}, é por nossa conta.",de:"Genießen Sie {r}.",fr:"Profitez de {r}.",es:"Disfruta de {r}.",it:"Goditi {r}."},
    playful: {en:"Yay! {r} unlocked!",pt:"Eba! Você ganhou {r}!",de:"Juhu! {r} freigeschaltet!",fr:"Youpi ! {r} débloqué !",es:"¡Bien! {r} desbloqueado!",it:"Evviva! {r} sbloccato!"},
    minimal: {en:"{r} unlocked",pt:"{r} desbloqueado",de:"{r} freigeschaltet",fr:"{r} débloqué",es:"{r} desbloqueado",it:"{r} sbloccato"}
  };

  function gspbAnimate() {
    var f = document.getElementById('gspb-fill');
    if (!f) return;
    var pct = (typeof window._gspbPct === 'number') ? window._gspbPct : 0;
    f.style.width = pct.toFixed(2) + '%';          // final state — always visible
    if (typeof f.animate === 'function') {
      try {
        f.animate([{ width: '0%' }, { width: pct.toFixed(2) + '%' }],
                  { duration: 750, easing: 'cubic-bezier(.22,1,.36,1)' });
      } catch (e) {}
    }
  }

  function renderProgress(cart) {
    var cfg     = window.gsCartProgress;
    var progEl  = document.getElementById('gs-prog');
    var msgEl   = document.getElementById('gspb-msg');
    var milesEl = document.getElementById('gspb-miles');
    var fillEl  = document.getElementById('gspb-fill');
    if (!progEl || !msgEl || !milesEl || !fillEl) return;
    if (!cfg || !cfg.milestones || !cfg.milestones.length) { progEl.style.display='none'; return; }

    var miles = cfg.milestones.filter(function(m){ return m && m.amount > 0; })
                              .sort(function(a,b){ return a.amount - b.amount; });
    if (!miles.length) { progEl.style.display='none'; return; }

    progEl.style.display = '';
    progEl.style.setProperty('--gspb-color', cfg.milestoneColor || '#111111');

    var total  = gsNonGiftCents(cart);   // exclude the free gift from progress/thresholds
    var n      = miles.length;
    var maxAmt = miles[n-1].amount || 1;
    var style  = window.gsCartProgressStyle || 'direct';

    function fmt(c){
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en',
          { style:'currency', currency: cfg.currency||'EUR', minimumFractionDigits:2, maximumFractionDigits:2 }
        ).format(c/100);
      } catch(e){ return '\u20ac' + (c/100).toFixed(2); }
    }
    function noEmoji(s){
      return String(s||'')
        .replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g,'')
        .replace(/[\u2190-\u21FF\u2300-\u27BF\u2B00-\u2BFF\u2600-\u26FF\uFE0F\u200D]/g,'')
        .replace(/\s{2,}/g,' ').trim();
    }

    /* Milestones — positioned proportionally along the rail */
    var mHtml = '';
    for (var i=0; i<n; i++) {
      var pos = (miles[i].amount / maxAmt * 100).toFixed(2);
      var on  = total >= miles[i].amount;
      var hasImg = !!miles[i].image;
      var ic  = hasImg
        ? '<img src="'+miles[i].image+'" alt="">'
        : (ICONS[miles[i].icon] || ICONS.star);
      mHtml += '<div class="gspb-mw" style="left:'+pos+'%">'
             +   '<div class="gspb-mc'+(on?' on':'')+(hasImg?' gspb-mc--img':'')+'">'+ic+'</div>'
             +   '<span class="gspb-lv'+(on?' on':'')+'">'+fmt(miles[i].amount)+'</span>'
             + '</div>';
    }
    milesEl.innerHTML = mHtml;

    /* Fill — store pct globally, render now AND on drawer open */
    window._gspbPct = Math.min(100, Math.max(0, total / maxAmt * 100));
    gspbAnimate();

    /* Message — i18n: reward (per milestone) + style (global) + store locale */
    var loc = String(cfg.locale || 'en').slice(0,2).toLowerCase();
    function L(d){ return (d && (d[loc] || d.en)) || ''; }
    var reached = -1;
    for (var j=n-1; j>=0; j--) { if (total >= miles[j].amount) { reached=j; break; } }
    var msg, tpl, rk, rwd;
    if (reached >= n-1) {
      rk = miles[n-1].reward;
      if (GSP_REWARDS[rk]) {
        msg = L(GSP_REACHED[style] || GSP_REACHED.casual).split('{r}').join(L(GSP_REWARDS[rk]));
      } else {
        msg = miles[n-1].reached || '';   // custom / legacy free text
      }
    } else {
      var ni = reached+1, rem = miles[ni].amount - total;
      rk = miles[ni].reward;
      if (GSP_REWARDS[rk]) {
        msg = L(GSP_PENDING[style] || GSP_PENDING.casual)
                .split('{r}').join(L(GSP_REWARDS[rk]))
                .split('{n}').join(fmt(rem));
      } else {
        msg = (miles[ni].pending || '{n}').split('{n}').join(fmt(rem));  // custom
      }
    }
        msgEl.textContent = noEmoji(msg);
  }

        function refreshCart(cb) {
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); if (cb) cb(c); })
      .catch(function () {});
  }
  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); })
      .catch(function () {});
  }

  /* ═══════════════════════════════════════════════════════════════
     ORDER BUMPS  (/collections/goatscale-bumps/products.json)
  ═══════════════════════════════════════════════════════════════ */

  var _autoAdded    = {};  // variantIds auto-adicionados nesta sessão
  var _toggleVarIds = {};  // variantIds de toggle bumps (escondidos dos itens normais)
  var _bumpsData    = [];  // cache dos produtos da coleção bumps
  var _bumpCompare  = {};  // variant_id -> compare_at (cents) p/ riscado no carrinho

  // Fallback do preço comparado dos bumps (título -> compare em cents).
  // Usado SÓ quando a vitrine não expõe compare_at (ex.: após troca de moeda da loja).
  // O catálogo de bumps é igual em todas as lojas, então este mapa é único/global.
  var GS_BUMP_COMPARE = {
    'Dior Sauvage Eau de Parfum (100ml)': 8990,
    'Dior Homme Intense (100ml)': 13990,
    'Valentino Uomo Born in Roma (100ml)': 12490,
    'Bleu de Chanel (100ml)': 10990
  };
  // Retorna o compare em cents p/ um produto de bump (vitrine -> fallback do mapa). 0 se não houver.
  function gsBumpCompareCents(p) {
    var v = p && p.variants && p.variants[0];
    if (!v) return 0;
    var pc = v.price ? Math.round(parseFloat(v.price) * 100) : 0;
    var cc = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
    if (!cc) { var t = (p.title || '').trim(); if (GS_BUMP_COMPARE[t]) cc = GS_BUMP_COMPARE[t]; }
    return cc > pc ? cc : 0;
  }

  function hasTag(p, tag) {
    var tags = p.tags;
    if (Array.isArray(tags)) return tags.indexOf(tag) !== -1;
    return String(tags || '').split(', ').indexOf(tag) !== -1;
  }

  // Pré-carrega a coleção bumps uma vez (chamado no init)
  function prefetchBumps(cb) {
    fetch('/collections/goatscale-bumps/products.json?limit=12')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        _bumpsData = d.products || [];
        _toggleVarIds = {};
        _bumpCompare = {};
        _bumpsData.forEach(function (p) {
          var v0 = p.variants && p.variants[0];
          if (v0) {
            var ccU = gsBumpCompareCents(p);
            if (ccU) _bumpCompare[String(v0.id)] = ccU;
          }
          if (hasTag(p, 'goatscale-toggle') || hasTag(p, 'goatscale-autoadd')) {
            var v = p.variants && p.variants[0];
            if (v) _toggleVarIds[String(v.id)] = true;
          }
        });
        if (cb) cb();
      })
      .catch(function () { if (cb) cb(); });
  }

  /* ═══════════════════════════════════════════════════════════════
     FREE PERFUME PICKER  (/collections/pick-3-perfumes-pay-for-1)
     Aparece quando o último milestone (perfume grátis) é atingido.
  ═══════════════════════════════════════════════════════════════ */
  var _giftData     = [];          // perfumes individuais (sem kits)
  var GIFT_PROP     = '_gift_perfume';

  function prefetchGift(cb) {
    if (cb) cb();
    return;
  }
  function _prefetchGiftUnused(cb) {
    fetch('/collections/pick-3-perfumes-pay-for-1/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        _giftData = (d.products || []).filter(function (p) {
          if (!(p.variants && p.variants.length)) return false;
          var t = String(p.title || '').toLowerCase();
          if (t.indexOf('kit') !== -1) return false;                 // exclui kits
          if (/\b3\b/.test(t) && (t.indexOf('perfume') !== -1 || t.indexOf('parf') !== -1)) return false;
          return true;
        });
        if (cb) cb();
      })
      .catch(function () { if (cb) cb(); });
  }

  // Escolhe a variante 100 ml (se existir), senão a 1ª disponível
  function pickGiftVariant(p) {
    var vs = p.variants || [];
    if (!vs.length) return null;
    var is100 = function (v) {
      var s = ((v.title || '') + ' ' + (v.option1 || '') + ' ' + (v.option2 || '')).toLowerCase();
      return /100\s*ml/.test(s);
    };
    var av = function (v) { return v.available !== false; };
    var v100 = vs.filter(is100);
    return v100.filter(av)[0] || v100[0] || vs.filter(av)[0] || vs[0];
  }

  // Define o brinde: remove brinde anterior (se houver) e adiciona o novo
  function chooseGift(vid) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var prev = (c.items || []).filter(function (it) { return it.properties && it.properties[GIFT_PROP]; });
      var addNew = function () {
        var body = { id: parseInt(vid, 10), quantity: 1, properties: {} };
        body.properties[GIFT_PROP] = '1';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }).then(function () { refreshCart(); }).catch(function () {});
      };
      if (prev.length) {
        var upd = {}; prev.forEach(function (it) { upd[it.key] = 0; });
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: upd }),
        }).then(addNew).catch(addNew);
      } else { addNew(); }
    }).catch(function () {});
  }

  // Milestone do perfume grátis (reward free_perfume; senão o último)
  function giftMilestone() {
    var cfg = window.gsCartProgress;
    if (!cfg || !cfg.milestones) return null;
    var miles = cfg.milestones.filter(function (m) { return m && m.amount > 0; })
                              .sort(function (a, b) { return a.amount - b.amount; });
    if (!miles.length) return null;
    for (var i = miles.length - 1; i >= 0; i--) { if (miles[i].reward === 'free_perfume') return miles[i]; }
    return null; // só mostra o picker se existir milestone de perfume grátis
  }

  function renderGiftPicker(cart) {
    var _og = document.getElementById('gs-gift'); if (_og) _og.remove();
    return;
  }
  function _renderGiftPickerUnused(cart) {
    var old = document.getElementById('gs-gift');
    if (old) old.remove();

    var gm = giftMilestone();
    if (!gm) return;
    var unlocked = gsNonGiftCents(cart) >= gm.amount;
    var existing = (cart.items || []).filter(function (it) { return it.properties && it.properties[GIFT_PROP]; });

    // Não qualificado: remove brinde residual e esconde o picker
    if (!unlocked) {
      if (existing.length) {
        var rm = {}; existing.forEach(function (it) { rm[it.key] = 0; });
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: rm }),
        }).then(function () { refreshCart(); }).catch(function () {});
      }
      return;
    }
    if (!_giftData.length) return;

    var body   = document.getElementById('gs-bd2');
    if (!body) return;
    var selVid = existing.length ? String(existing[0].variant_id) : '';

    var cards = _giftData.map(function (p) {
      var v = pickGiftVariant(p);
      if (!v) return '';
      var vid = String(v.id);
      var img = p.images && p.images[0] ? resizeImg(p.images[0].src, '200x200') : '';
      var sel = vid === selVid;
      return '<div class="gs-gp' + (sel ? ' sel' : '') + '">' +
        (img ? '<img class="gs-gp-img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">'
             : '<div class="gs-gp-img"></div>') +
        '<div class="gs-gp-nm">' + esc(p.title) + '</div>' +
        '<div class="gs-gp-bd"><span class="gs-bdg gs-bdg-ml">100 ML</span>' +
          '<span class="gs-bdg gs-bdg-free">' + _gt('gift_free') + '</span></div>' +
        '<button class="gs-gp-btn" data-vid="' + esc(vid) + '">' +
          (sel ? '✓' : _gt('gift_choose')) + '</button>' +
      '</div>';
    }).join('');

    var wrap = document.createElement('div');
    wrap.id  = 'gs-gift';
    wrap.innerHTML =
      '<div class="gs-gift-h">' + ICONS.gift +
        '<span>' + (selVid ? _gt('gift_chosen') : _gt('gift_title')) + '</span></div>' +
      '<div class="gs-gift-row">' + cards + '</div>';
    // Fixa o picker logo ABAIXO da barra de progresso (fora do scroll dos itens),
    // colado, para o cliente ver sempre o bloco de seleção do perfume grátis.
    var prog = document.getElementById('gs-prog');
    if (prog && prog.insertAdjacentElement) { prog.insertAdjacentElement('afterend', wrap); }
    else { body.appendChild(wrap); }

    wrap.querySelectorAll('.gs-gp-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = btn.dataset.vid;
        if (!vid || String(vid) === String(selVid)) return;
        btn.textContent = '...';
        chooseGift(vid);
      });
    });

    var selCard = wrap.querySelector('.gs-gp.sel');
    if (selCard && selCard.scrollIntoView) {
      try { selCard.scrollIntoView({ inline: 'center', block: 'nearest' }); } catch (e) {}
    }
  }

  function loadBumps(cart) {
    var old = document.getElementById('gs-bumps');
    if (old) old.remove();
    if (!_bumpsData.length) return;

    var cartHandles = (cart.items || []).map(function (i) { return i.handle; });
    var cartVarIds  = (cart.items || []).map(function (i) { return String(i.variant_id); });

    // Auto-add: produtos com goatscale-autoadd não no carrinho
    _bumpsData.forEach(function (p) {
      if (!hasTag(p, 'goatscale-autoadd')) return;
      var v = p.variants && p.variants[0];
      if (!v) return;
      var vid = String(v.id);
      if (cartVarIds.indexOf(vid) !== -1) return;
      var _decl = false; try { _decl = sessionStorage.getItem('gs_va_' + vid) === 'off'; } catch (e) {}
      if (_decl) return;
      if (_autoAdded[vid]) return;
      _autoAdded[vid] = true;
      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }),
      }).then(function () { refreshCart(); }).catch(function () {});
    });

    // Toggles (ex.: Versandschutz autoadd) SEMPRE no fim e sempre visiveis;
    // normais limitados a 4 antes deles.
    var _isTgl = function (p) { return hasTag(p, 'goatscale-toggle') || hasTag(p, 'goatscale-autoadd'); };
    var _tgls  = _bumpsData.filter(_isTgl);
    var _norms = _bumpsData.filter(function (p) { return !_isTgl(p) && cartHandles.indexOf(p.handle) === -1; });
    var toShow = _norms.slice(0, 4).concat(_tgls);

    if (toShow.length) renderBumps(toShow, cartVarIds);
  }

  function renderBumps(prods, cartVarIds) {
    var body = document.getElementById('gs-bd2');
    if (!body) return;

    var wrap = document.createElement('div');
    wrap.id  = 'gs-bumps';
    wrap.innerHTML = '<div class="gs-bh">'+_gt('bumps')+'</div>' +
      prods.map(function (p) {
        var v       = p.variants && p.variants[0] ? p.variants[0] : {};
        var vid     = String(v.id || '');
        var pc      = v.price ? Math.round(parseFloat(v.price) * 100) : 0;
        var cc      = gsBumpCompareCents(p);
        var img     = p.images && p.images[0] ? resizeImg(p.images[0].src, '120x120') : '';
        var isToggle = hasTag(p, 'goatscale-toggle') || hasTag(p, 'goatscale-autoadd');
        var inCart   = cartVarIds && cartVarIds.indexOf(vid) !== -1;
        var _decl2 = false; try { _decl2 = sessionStorage.getItem('gs_va_' + vid) === 'off'; } catch (e) {}
        var checked  = (isToggle && (inCart || (hasTag(p, 'goatscale-autoadd') && !_decl2))) ? 'checked' : '';
        var uid      = 'gs-tgl-' + vid;

        var ctrl = isToggle
          ? '<label class="gs-tgl" for="'+uid+'" title="Remover do pedido">' +
              '<input type="checkbox" id="'+uid+'" data-vid="'+esc(vid)+'" ' + checked + '>' +
              '<span class="gs-tgl-sl"></span>' +
            '</label>'
          : '<button class="gs-bmp-btn" data-vid="'+esc(vid)+'">'+_gt('add')+'</button>';

        return '<div class="gs-bmp">' +
          (img ? '<img class="gs-bmp-img" src="'+esc(img)+'" alt="'+esc(p.title)+'" loading="lazy">'
               : '<div class="gs-bmp-img"></div>') +
          '<div class="gs-bmp-inf"><p class="gs-bmp-t">'+esc(p.title)+'</p>' +
          '<p class="gs-bmp-p">'+$m(pc)+(cc > pc ? ' <s class="gs-bmp-was">'+$m(cc)+'</s>' : '')+'</p></div>' +
          ctrl +
        '</div>';
      }).join('');

    body.appendChild(wrap);

    // Botão "Add" — bumps normais
    wrap.querySelectorAll('.gs-bmp-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!btn.dataset.vid) return;
        btn.disabled = true; btn.textContent = '...';
        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: parseInt(btn.dataset.vid, 10), quantity: 1 }),
        }).then(function () {
          btn.textContent = '+'; btn.classList.add('ok');
          refreshCart();
        }).catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
      });
    });

    // Toggle — bumps automáticos
    wrap.querySelectorAll('.gs-tgl input').forEach(function (chk) {
      chk.addEventListener('change', function () {
        var vid = chk.dataset.vid;
        if (!vid) return;
        if (chk.checked) {
          try { sessionStorage.removeItem('gs_va_' + vid); } catch (e) {}
          // Adicionar ao carrinho
          fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }),
          }).then(function () { refreshCart(); }).catch(function () {});
        } else {
          try { sessionStorage.setItem('gs_va_' + vid, 'off'); } catch (e) {}
          // Remover do carrinho — encontra a key do item
          fetch('/cart.js').then(function (r) { return r.json(); })
            .then(function (c) {
              var item = (c.items || []).find(function (i) { return String(i.variant_id) === vid; });
              if (item) changeQty(item.key, 0);
            }).catch(function () {});
        }
      });
    });
  }

  /* ═══════════════════════════════════════════════════════════════
     FETCH INTERCEPT — captura qualquer /cart/add do tema
  ═══════════════════════════════════════════════════════════════ */
  
  /* ── gsOpenCart: adiciona itens ao carrinho Black e abre o drawer ──
     Os handlers de CTA do tema (gs_bundle, gs_buy_row, gs_add_bundle e a
     sticky-atc) chamam window.gsOpenCart([{id,quantity}]); sem esta definicao
     o clique lanca TypeError e o botao trava. */
  window.gsOpenCart = function (items) {
    var list = (Array.isArray(items) ? items : [items]).map(function (it) {
      return { id: parseInt(it.id, 10), quantity: parseInt(it.quantity, 10) || 1 };
    }).filter(function (it) { return it.id; });
    if (!list.length) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: list })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add ' + r.status);
      return r.json();
    }).then(function (data) { try { refreshCart(openD); } catch (e) {} return data; });
  };

  window.gsShowCart = function(){ try{ refreshCart(openD); }catch(e){} };

  var _origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var pr  = _origFetch.apply(this, arguments);

    // Ignore our own internal refreshCart / changeQty / loadBumps calls
    if (url && String(url).indexOf('/cart/add') !== -1) {
      pr.then(function (r) {
        if (r && r.ok) {
          // Neutralize native cart again (Horizon re-injects on every add)
          neutralizeNativeCart();
          setTimeout(function () { refreshCart(openD); }, 200);
        }
      }).catch(function () {});
    }
    return pr;
  };

  /* ═══════════════════════════════════════════════════════════════
     XHR INTERCEPT — fallback for older theme scripts
  ═══════════════════════════════════════════════════════════════ */
  (function () {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._gsUrl = String(url || '');
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this._gsUrl && this._gsUrl.indexOf('/cart/add') !== -1) {
        var self = this;
        self.addEventListener('load', function () {
          if (self.status >= 200 && self.status < 300) {
            neutralizeNativeCart();
            setTimeout(function () { refreshCart(openD); }, 200);
          }
        });
      }
      return origSend.apply(this, arguments);
    };
  }());

  /* ═══════════════════════════════════════════════════════════════
     CHECKOUT → loja White (variante exacta)
  ═══════════════════════════════════════════════════════════════ */
  var _ic = {};

  var GS_STATIC = {"67621564383534":67631099478326,"67621525127470":67631098233142,"67621538332974":67631098200374,"67621554094382":67631098790198,"67621547933998":67631098724662,"67621554192686":67631098822966,"67621522440494":67631097807158,"67621554258222":67631098855734,"67621524996398":67631098134838,"67621545902382":67631098691894,"67621522702638":67631097872694,"67621540790574":67631098429750,"67621522243886":67631097708854,"67621522145582":67631099412790,"67621556322606":67631098954038,"67621543149870":67631098593590,"67621542887726":67631098528054,"67621543051566":67631098560822,"67621553766702":67631098757430,"67621545804078":67631098659126,"67621554356526":67631098888502,"67621559042350":67631099052342,"67621525291310":67631098167606,"67621522178350":67631097676086,"67621522571566":67631097839926,"67621524799790":67631098036534,"67621538431278":67631098265910,"67621543575854":67631098626358,"67621522276654":67631097741622,"67621524898094":67631098069302,"67621522735406":67631097905462,"67621522866478":67631097938230,"67621522506030":67631099511094,"67621522407726":67631097774390,"67621540954414":67631098495286,"67621524734254":67631098003766,"67621524930862":67631098102070,"67621556224302":67631098921270,"67621522899246":67631097970998,"67621540593966":67631098331446,"67621556486446":67631098986806,"67621557076270":67631099019574,"67621559697710":67631099085110,"67621559796014":67631099117878,"67621559894318":67631099150646,"67621561827630":67631099216182,"67621561762094":67631099183414,"67621561958702":67631099281718,"67621564285230":67631099380022,"67621563892014":67631099314486,"67621525324078":67631099576630,"67621525487918":67631099609398,"67621527290158":67631099642166,"67621527355694":67631099707702,"67621527388462":67631099740470,"67621527453998":67631099773238,"67621527486766":67631099838774,"67621527552302":67631099871542,"67621527585070":67631099904310,"67621527748910":67631099969846,"67621527781678":67631100002614,"67621527847214":67631100035382,"67621527879982":67631100068150,"67621527945518":67631100100918,"67621527978286":67631100133686,"67621528174894":67631100166454,"67621529977134":67631100199222,"67621530108206":67631100231990,"67621530140974":67631100264758,"67621530206510":67631100297526,"67621530239278":67631100330294,"67621530337582":67631100363062,"67621530566958":67631100395830,"67621530632494":67631100428598,"67621530665262":67631100461366,"67621530992942":67631100494134,"67621532893486":67631100526902,"67621532959022":67631100559670,"67621532991790":67631100625206,"67621533155630":67631100657974,"67621533188398":67631100690742,"67621533253934":67631100723510,"67621533286702":67631100756278,"67621533385006":67631100789046,"67621533450542":67631100821814,"67621533483310":67631100854582,"67621533548846":67631100887350,"67621533647150":67631100920118,"67621535482158":67631100952886,"67621535514926":67631101018422,"67621535613230":67631101051190,"67621535645998":67631101083958,"67621535744302":67631101116726,"67621535777070":67631101149494,"67621535842606":67631101182262,"67621535973678":67631101215030,"67621536039214":67631101247798,"67621536104750":67631101280566,"67621537939758":67631101313334,"67621537972526":67631101346102,"67621538038062":67631101378870,"67621538070830":67631101411638,"67621538136366":67631101444406,"67621538169134":67631101477174,"67622103286062":67631107703094,"67622103548206":67631109505334,"67622103679278":67631109538102,"67622103908654":67631109603638,"67622124749102":67631109636406};
  var GS_STATIC_HOST = 'essenzalondon.uk';
  function getWhiteInfo(handle, blackVarId, isGift, cb) {
    if (!isGift && GS_STATIC[String(blackVarId)]) { cb({ variantId: GS_STATIC[String(blackVarId)], domain: GS_STATIC_HOST }); return; }
    var k = (isGift ? 'gift:' : '') + handle + ':' + blackVarId;
    if (_ic[k] !== undefined) { cb(_ic[k]); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var tags = p.tags || [];
        // Item-brinde: mapeia para a versão GIFT (G##) na White via goatscale-gift-url,
        // pra ficar FORA da coleção do Pick-3 (sem conflito). O desconto automático libera ela.
        if (isGift) {
          var gtag = tags.find(function (t) { return t.indexOf('goatscale-gift-url:') === 0; });
          if (gtag) {
            try {
              var gu = gtag.replace('goatscale-gift-url:', '').trim();
              var gdom = new URL(gu).hostname;
              var gm = gu.match(/\/cart\/(\d+):/);
              if (gm) { _ic[k] = { variantId: gm[1], domain: gdom }; cb(_ic[k]); return; }
            } catch (e) {}
          }
          _ic[k] = null; cb(null); return;
        }
        var vtag = tags.find(function (t) {
          return t.indexOf('goatscale-variant:' + blackVarId + ':') === 0;
        });
        var urlTag = tags.find(function (t) { return t.indexOf('goatscale-url:') === 0; });
        var domain = null;
        if (urlTag) {
          try { domain = new URL(urlTag.replace('goatscale-url:', '').trim()).hostname; } catch (e) {}
        }
        if (vtag && domain) {
          _ic[k] = { variantId: vtag.split(':')[2], domain: domain };
          cb(_ic[k]); return;
        }
        if (urlTag) {
          var m = urlTag.replace('goatscale-url:', '').trim().match(/\/cart\/(\d+):/);
          if (m && domain) { _ic[k] = { variantId: m[1], domain: domain }; cb(_ic[k]); return; }
        }
        _ic[k] = null; cb(null);
      })
      .catch(function () { _ic[k] = null; cb(null); });
  }

  function buildWhiteUrl(items, done) {
    if (!items.length) { done(null); return; }
    var pend = items.length, parts = new Array(items.length).fill(null), dom = null;
    items.forEach(function (it, i) {
      getWhiteInfo(it.handle, String(it.variantId), it.isGift, function (info) {
        if (info) { parts[i] = info.variantId + ':' + it.quantity; if (!dom) dom = info.domain; }
        if (--pend === 0) {
          var f = parts.filter(Boolean);
          if (f.length && dom) {
            // Append gs_return so White store can show "← Back" button
            var ret = encodeURIComponent(window.location.origin + '/cart');
            done('https://' + dom + '/cart/' + f.join(',') + '?gs_return=' + ret);
          } else {
            done(null);
          }
        }
      });
    });
  }

  /* ── Checkout preload: warm the White mapping + TLS connection so checkout is instant ── */
  var _gsCk = null;            // prebuilt White checkout URL (incl. gift attribute)
  var _gsPreconnected = {};
  function gsPreconnect(url) {
    try {
      var origin = new URL(url).origin;
      if (_gsPreconnected[origin]) return;
      _gsPreconnected[origin] = true;
      ['preconnect', 'dns-prefetch'].forEach(function (rel) {
        var l = document.createElement('link');
        l.rel = rel; l.href = origin; if (rel === 'preconnect') l.crossOrigin = '';
        document.head.appendChild(l);
      });
    } catch (e) {}
  }
  var _gsPrefetchLink = null;
  function gsPrefetch(url) {
    // Best-effort warm-up of the White cart/checkout page (cross-origin prefetch). Replaces the
    // previous link so it always reflects the current cart. Harmless if the browser ignores it.
    try {
      if (_gsPrefetchLink && _gsPrefetchLink.href === url) return;
      if (_gsPrefetchLink && _gsPrefetchLink.parentNode) _gsPrefetchLink.parentNode.removeChild(_gsPrefetchLink);
      var l = document.createElement('link');
      l.rel = 'prefetch'; l.href = url; l.as = 'document';
      document.head.appendChild(l);
      _gsPrefetchLink = l;
    } catch (e) {}
  }
  function prebuildCheckout(cart) {
    var items = (cart && cart.items || []).map(function (it) {
      return { handle: it.handle, quantity: it.quantity, variantId: it.variant_id,
               isGift: !!(it.properties && it.properties[GIFT_PROP]) };
    });
    if (!items.length) { _gsCk = null; return; }
    buildWhiteUrl(items, function (url) {
      if (!url) { _gsCk = null; return; }
      gsPreconnect(url);
      var sep = url.indexOf('?') >= 0 ? '&' : '?';
      url += sep + 'attributes[locale]=' + encodeURIComponent(GSD_LANG);
      _gsCk = url;
      gsPrefetch(url);   // pré-aquece a página do carrinho/checkout da White
    });
  }

  var _co = false;
  function doCheckout() {
    if (_co) return; _co = true;

    // Visual feedback on any active checkout button
    var btn = document.getElementById('gs-ck');
    if (btn) { btn.disabled = true; btn.textContent = _gt('redirecting'); }

    // Also disable any native checkout button that triggered this
    if (_lastCkBtn && _lastCkBtn !== btn) {
      _lastCkBtn.disabled = true;
      _lastCkBtn._origText = _lastCkBtn.textContent || _lastCkBtn.value || '';
      if (_lastCkBtn.tagName === 'INPUT') _lastCkBtn.value = '...';
      else _lastCkBtn.textContent = '...';
    }

    // Instant path: redirect to the prebuilt White checkout URL (warmed on cart render).
    if (_gsCk) { window.location.href = _gsCk; return; }

    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) {
        // O item-brinde (GIFT_PROP) é mapeado para a versão GIFT (G##) na White, que fica numa
        // coleção separada -> o Pick-3 ignora, e o desconto BXGY automático (gastar €129,90 em
        // perfumes/kits reais -> 1 da coleção Gift grátis) libera o brinde. Sem código, sem conflito.
        var items = (cart.items || []).map(function (it) {
          return { handle: it.handle, quantity: it.quantity, variantId: it.variant_id,
                   isGift: !!(it.properties && it.properties[GIFT_PROP]) };
        });
        buildWhiteUrl(items, function (url) {
          if (url) {
            var sep = url.indexOf('?') >= 0 ? '&' : '?';
            url += sep + 'attributes[locale]=' + encodeURIComponent(GSD_LANG);
            window.location.href = url;
          } else {
            _co = false;
            if (btn) { btn.disabled = false; btn.textContent = _gt('checkout'); }
            if (_lastCkBtn && _lastCkBtn !== btn) {
              _lastCkBtn.disabled = false;
              if (_lastCkBtn.tagName === 'INPUT') _lastCkBtn.value = _lastCkBtn._origText;
              else _lastCkBtn.textContent = _lastCkBtn._origText;
            }
          }
        });
      }).catch(function () {
        _co = false;
        if (btn) { btn.disabled = false; btn.textContent = _gt('checkout'); }
      });
  }

  /* ═══════════════════════════════════════════════════════════════
     INTERCEPT ALL CHECKOUT BUTTONS (cart page + theme buttons)
     Captures: [name="checkout"], .cart__checkout-button,
               a[href="/checkout"], form action="/checkout"
  ═══════════════════════════════════════════════════════════════ */
  var _lastCkBtn = null;

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target) return;

    var el = target.closest
      ? target.closest('[name="checkout"], .cart__checkout-button, [data-checkout-button], a[href="/checkout"]')
      : null;

    // Fallback for browsers without closest
    if (!el) {
      var name = target.getAttribute && target.getAttribute('name');
      var href = target.getAttribute && target.getAttribute('href');
      if (name === 'checkout' || href === '/checkout') el = target;
    }

    if (!el) return;
    if (el.id === 'gs-ck') return; // already handled by drawer button

    e.preventDefault();
    e.stopImmediatePropagation();
    _lastCkBtn = el;
    doCheckout();
  }, true);

  // Also intercept cart form submissions (some themes submit the cart form)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form) return;
    var action = form.getAttribute('action') || '';
    if (!action.includes('/checkout') && action !== '/cart') return;
    var ckBtn = form.querySelector('[name="checkout"]');
    if (!ckBtn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    _lastCkBtn = ckBtn;
    doCheckout();
  }, true);

  /* ═══════════════════════════════════════════════════════════════
     CART ICON — open drawer when clicking the header bag icon
  ═══════════════════════════════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest
      ? e.target.closest('#cart-icon-bubble, [href="/cart"], [href="{{ routes.cart_url }}"]')
      : null;
    if (!el) return;
    // Only intercept if our drawer exists; otherwise let the default navigate
    var drawer = document.getElementById('gs-dw');
    if (!drawer) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    refreshCart(openD);
  }, true);

  /* ═══════════════════════════════════════════════════════════════
     BOOT
  ═══════════════════════════════════════════════════════════════ */
  function init() {
    injectDrawer();
    neutralizeNativeCart();
    prefetchBumps(); // pré-carrega bumps para saber quais esconder dos itens do carrinho
    prefetchGift();  // pré-carrega perfumes individuais para o picker de brinde grátis
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
